import { Component, input, Input } from '@angular/core';
import { QuestionnaireStatus } from '../models';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'fgai-questionnaire-status',
    imports: [CommonModule],
    templateUrl: './questionnaire-status.html',
    styleUrl: './questionnaire-status.scss',
})
export class QuestionnaireStatusComponent {
    status = input<QuestionnaireStatus | 'NEW'>('NEW');
}
